'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.threadSupportsAttachments = undefined;

var _reselect = require('reselect');

var _threadFromProps = require('../../threads/selectors/threadFromProps');

var _isPersistedThread = require('../../thread-histories/operators/isPersistedThread');

var threadSupportsAttachments = exports.threadSupportsAttachments = (0, _reselect.createSelector)([_threadFromProps.threadFromProps], function (thread) {
  return (0, _isPersistedThread.isPersistedThread)(thread);
});


//////////////////
// WEBPACK FOOTER
// ./js/visitor-widget/selectors/threadSupportsAttachments.js
// module id = 659
// module chunks = 2 3